import { Button, PageHeader } from 'antd'
import React from 'react'
import { Link } from 'react-router-dom'
import ContraVoucherEntryView from '../../components/account/contra/ContraVoucherEntryView'
import AdminBreadCrumb from '../../components/layout/AdminBreadCrumb'

const ContraVoucher = () => {
  return (
    <div className='inside-main-content'>

      <AdminBreadCrumb />

        <div className="box-style" >
            <PageHeader
            ghost={false}
            onBack={() => window.history.back()}
            title="Contra Voucher Entry"
            subTitle=""
            extra={[
                <Link to={`/contravoucher/list`} key="reg_list">
                <Button key="1" shape='round' className='custom-button-white'> List</Button>
                </Link>

            
            ]}
            >

            </PageHeader>


            <ContraVoucherEntryView />

        </div>
    </div>
  )
}

export default ContraVoucher